export default __webpack_public_path__ + "static/media/triflex-icon-48px.0736cefc.svg";